import { render, staticRenderFns } from "./PhotoPreview.vue?vue&type=template&id=4f38cbe0&"
import script from "./PhotoPreview.vue?vue&type=script&lang=ts&"
export * from "./PhotoPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports